<template>
    <svg
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="33">
        <g clip-path="url(#clip0_3023_165)">
            <path
                d="M0 16.7383H32"
                stroke="currentColor"
                stroke-width="2" />
            <path
                d="M16 32.7383L16 0.738282"
                stroke="currentColor"
                stroke-width="2" />
        </g>
        <defs>
            <clipPath id="clip0_3023_165">
                <rect
                    fill="currentColor"
                    transform="translate(0 0.738281)"
                    width="32"
                    height="32" />
            </clipPath>
        </defs>
    </svg>
</template>
